// Certains champs texte de l'API (ex. titres de traductions) contiennent des entités HTML brutes
// (ex. "s&#259;u" au lieu de "său") au lieu du caractère réel. Rendu tel quel via JSX, React
// échappe ce texte comme du contenu littéral : l'entité s'affiche donc mot pour mot ("&#259;")
// plutôt que d'être interprétée. On la décode donc explicitement avant affichage, aussi bien côté
// serveur (SSR, pas de DOMParser/textarea disponible dans Node) que client, d'où cette
// implémentation manuelle plutôt qu'un décodage via le DOM.
const NAMED_ENTITIES = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
};

export function decodeHtmlEntities(text) {
  if (!text) {
    return text;
  }

  return String(text).replace(/&(#x[0-9a-fA-F]+|#[0-9]+|[a-zA-Z]+);/g, (match, entity) => {
    if (entity[0] === '#') {
      const code =
        entity[1] === 'x' || entity[1] === 'X' ? parseInt(entity.slice(2), 16) : parseInt(entity.slice(1), 10);
      return Number.isNaN(code) ? match : String.fromCodePoint(code);
    }
    return NAMED_ENTITIES[entity] || match;
  });
}
